import { MESSAGE_STATUSES } from '../models/messaging-message';
import { concat, fn } from '@ember/helper';
import { decodeText, decodeTextWithLinks } from '../utils/messaging/format-text';
import { eq } from 'ember-truth-helpers';
import { formatDate } from '../utils/messaging/format-date';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import Component from '@glimmer/component';
import styles from './conversation-message.module.scss';

const CONVERSATION_TRUNCATED_MESSAGE = 'CONVERSATION_TRUNCATED';

export default class ConversationMessage extends Component {
  @service messaging;
  @service messagingConversation;
  @service intl;

  get parsedSystemMessage() {
    let { text, createdAt } = this.args.message;

    if (text !== CONVERSATION_TRUNCATED_MESSAGE) {
      return decodeText(
        text.replace(
          'on %created_at%',
          `at ${formatDate(new Date(createdAt))}`.replaceAll(' ', '&nbsp;')
        )
      );
    }

    let footer = this.messaging.currentProfile.isSuperUser
      ? this.intl.t('emc.truncated_system_message.footer')
      : '';

    return this.intl.t('emc.truncated_system_message.text', {
      date: formatDate(new Date(createdAt)),
      footer,
    });
  }

  get mostRecentOwnMessage() {
    let messages = this.messagingConversation.messages;
    return messages?.find(message => !message.isSystem && message.isOwn);
  }

  shouldShowSendingStatus = message => {
    return (
      message.status === MESSAGE_STATUSES.FAILED ||
      message.status === MESSAGE_STATUSES.SENDING ||
      (message.status === MESSAGE_STATUSES.DELIVERED && message === this.mostRecentOwnMessage)
    );
  };

  <template>
    <div
      class="{{styles.component}}
        conversation-message
        {{if @message.isOwn 'own'}}
        {{if @message.isSystem 'system'}}"
      data-test-conversation-page-message
    >
      {{#if @message.isSystem}}
        <span class="message-text" data-test-system-message>{{this.parsedSystemMessage}}</span>
      {{else}}
        <div class="message-wrapper">
          {{#unless @message.isOwn}}
            <div class="avatar">
              <span class="initials" data-test-initials>{{@message.user.initials}}</span>
            </div>
          {{/unless}}
          <div class="message">
            <span class="message-text" data-test-message-text>
              {{decodeTextWithLinks @message.text}}
            </span>
            <div class="message-info">
              {{#if @message.isOwn}}
                <span data-test-sent-indicator>Sent</span>
              {{else}}
                <span data-test-user-name>{{@message.user.name}}</span>
              {{/if}}
              <span class="time" data-test-created-at>· {{formatDate @message.createdAt}}</span>
            </div>
          </div>
        </div>
        {{#if (this.shouldShowSendingStatus @message)}}
          {{#if (eq @message.status MESSAGE_STATUSES.FAILED)}}
            <div class="sending-status" data-test-sending-status={{@message.status}}>
              <span
                class="failed"
                role="button"
                {{on "click" (fn @onResend @message)}}
                data-test-resend
              >
                {{t "emc.message_status.failed"}}
              </span>
            </div>
          {{else}}
            <div class="sending-status" data-test-sending-status={{@message.status}}>
              {{t (concat "emc.message_status." @message.status)}}
            </div>
          {{/if}}
        {{/if}}
      {{/if}}
    </div>
  </template>
}
